module.exports = __webpack_public_path__ + "static/media/imagenservicios2.8a23db85.png";